import types from './types';

// TODO Get rid of thunks here
export const saveTrackingData = (data) => (dispatch) => {
    dispatch({
        type: types.SAVE_TRACKING_DATA,
        payload: data
    });
};

// TODO Get rid of thunks here
export const saveImpressionData = (data) => (dispatch) => {
    dispatch({
        type: types.SAVE_IMPRESSION_DATA,
        payload: data
    });
};

// TODO Get rid of thunks here
export const clearImpressionData = () => (dispatch) => {
    dispatch({
        type: types.CLEAR_IMPRESSION_DATA
    });
};
